import type { JSX, ReactNode } from "react";

export type FieldProps = Readonly<{
  label: string;
  children: ReactNode;
}>;

/**
 * A labelled form row in the panel visual language.
 *
 * A `div` rather than a `label`: the library's Select and NumberInput render
 * their own composite controls, so a wrapping label would have nothing valid
 * to point at.
 */
export function Field({ label, children }: FieldProps): JSX.Element {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">{label}</span>
      {children}
    </div>
  );
}
